import { PlaceholderPage } from "./placeholder-page";

export function AdvancedPricingPage() {
  return (
    <PlaceholderPage 
      title="Advanced Pricing" 
      description="This feature is planned for a future release."
    />
  );
}
